import TextAreaInputWithLabel from './TextAreaInputWithLabel';

export default TextAreaInputWithLabel;
